import(/* webpackMode: "eager", webpackExports: ["MedicoContent"] */ "/app/app/medico/medico-content.tsx");
